import PropTypes from 'prop-types';
import React, { createContext, useContext, useMemo, useState } from 'react';

const AssetFormContext = createContext();

const Provider = ({ children }) => {
  const [asset, setAsset] = useState(null);
  const [location, setLocation] = useState(null);
  const [isLocationClone, setIsLocationClone] = useState(false);
  const [isLocationFormOpen, setIsLocationFormOpen] = useState(false);

  const value = useMemo(
    () => ({
      asset,
      setAsset,
      location,
      setLocation,
      isLocationFormOpen,
      setIsLocationFormOpen,
      isLocationClone,
      setIsLocationClone,
    }),
    [asset, isLocationClone, isLocationFormOpen, location],
  );

  return (
    <AssetFormContext.Provider value={value}>
      {children}
    </AssetFormContext.Provider>
  );
};

export const useAssetFormContext = () => useContext(AssetFormContext);

Provider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default Provider;
